import { render, staticRenderFns } from "./workspace-right-sidebar.html?vue&type=template&id=63575c5b&scoped=true&"
import script from "./workspace-right-sidebar.js?vue&type=script&lang=js&"
export * from "./workspace-right-sidebar.js?vue&type=script&lang=js&"
import style0 from "./workspace-right-sidebar.scss?vue&type=style&index=0&id=63575c5b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63575c5b",
  null
  
)

export default component.exports